// French for the dashboard: masthead, rail, the four zones and the delete-engagement modal.
import { registerFr } from '../i18n/index.js';

registerFr({
  // routeLabel
  'Below': 'Plus bas',
  'Open': 'Ouvrir',
  'Timeline': 'Chronologie',
  'Client': 'Client',
  'Documents': 'Documents',
  'Register': 'Registre',
  'Agent': 'Agent',
  'Proposals': 'Propositions',
  'Contracting': 'Contrat',
  'Acceptance': 'Acceptation',
  'Lifecycle': 'Cycle de vie',
  'Portal admin': 'Administration du portail',
  // toasts
  'Nothing on this page is anchored at {id}.': 'Rien sur cette page n’est ancré à {id}.',
  'This item names a client surface but carries no client.': 'Cet élément nomme une vue client mais ne porte aucun client.',
  "No page is named '{screen}'.": 'Aucune page ne s’appelle «{screen}».',
  '{code} deleted — {gone} went with it': '{code} supprimé — {gone} sont partis avec',
  '{code} deleted': '{code} supprimé',
  '{code} archived — every row stays, it just leaves the active list': '{code} archivé — chaque ligne reste, le mandat quitte seulement la liste active',
  '{code} created': '{code} créé',
  // load failure
  'The dashboard brief could not be loaded': 'Le briefing du dashboard n’a pas pu être chargé',
  'The {path} endpoint answered: “{answer}”': 'Le point de terminaison {path} a répondu : «{answer}»',
  'no response': 'aucune réponse',
  // masthead
  'Dashboard': 'Dashboard',
  'signed in as': 'connecté en tant que',
  'last here': 'dernière visite',
  'first visit': 'première visite',
  'New engagement': 'Nouveau mandat',
  // rail
  'Live': 'Actif',
  'Moves': 'Coups',
  'Clock': 'Horloge',
  'Ball': 'Balle',
  'New': 'Nouveau',
  // zone 1
  'Next move': 'Prochain coup',
  'Ranked by the rule engine.': 'Classé par le moteur de règles.',
  'item; every one names its engagement and its screen.': 'élément ; il nomme son mandat et son écran.',
  'items; every one names its engagement and its screen.': 'éléments ; chacun nomme son mandat et son écran.',
  'Nothing in the queue — and the statement below names every gate it is claiming passes.': 'Rien dans la file d’attente — et la déclaration ci-dessous nomme chaque gate qu’elle revendique comme franchi.',
  '{n} more, lower weight — {titles}': '{n} de plus, poids inférieur — {titles}',
  'Show fewer': 'Afficher moins',
  'rule {rule} · w{weight}': 'règle {rule} · p{weight}',
  'No move can be computed': 'Aucun coup calculable',
  'There is no live engagement on file, so no rule has a subject. Nothing can be gated, proposed or contracted until one exists.': 'Aucun mandat actif n’est enregistré, donc aucune règle n’a de sujet. Rien ne peut être soumis à un gate, proposé ou contractualisé tant qu’aucun n’existe.',
  'proposed by the agent, not yet committed': 'proposé par l’agent, pas encore retenu',
  'derived check': 'vérification dérivée',
  // zone 2
  'The clocks': 'Les horloges',
  'Dated obligations only — ours and theirs. An age with no date is a move, not a clock.': 'Seulement les obligations datées — les nôtres et les leurs. Une ancienneté sans date est un coup, pas une horloge.',
  'What': 'Quoi',
  'Due': 'Échéance',
  'Standing': 'État',
  'No clock is running': 'Aucune horloge n’est en marche',
  'No milestone carries a due date, no acceptance record is issued and no commitment has a date against it. That is a real state, not a missing panel —': 'Aucun jalon ne porte de date d’échéance, aucun procès-verbal d’acceptation n’est délivré et aucune promesse n’a de date associée. C’est un état réel, pas un panneau manquant —',
  'dated obligations exist.': 'des obligations datées existent.',
  // zone 3
  'Moved without you': 'A bougé sans vous',
  'Agent runs, portal actions and sign-offs. Your own edits are not news.': 'Exécutions de l’agent, actions du portail et validations. Vos propres modifications ne sont pas une nouveauté.',
  'Nothing has moved since you were last here': 'Rien n’a bougé depuis votre dernière visite',
  'This is your first visit, so nothing can be new yet.': 'C’est votre première visite, donc rien ne peut encore être nouveau.',
  'The last': 'Les',
  'thing that moved': 'dernière chose qui a bougé',
  'things that moved': 'dernières choses qui ont bougé',
  'without': 'sans',
  'you:': 'vous :',
  'Nothing has moved without you': 'Rien n’a bougé sans vous',
  'No agent run has closed, no portal user has acted and no sign-off has been recorded': 'Aucune exécution de l’agent n’est terminée, aucun utilisateur du portail n’a agi et aucune validation n’a été enregistrée',
  'since': 'depuis',
  '— nothing has ever been recorded here': '— rien n’a jamais été enregistré ici',
  'Your own edits are not listed here; you already know about those.': 'Vos propres modifications ne figurent pas ici ; vous les connaissez déjà.',
  // zone 4
  'Engagements': 'Mandats',
  'live': 'actif',
  'archived': 'archivé',
  'Hide archived': 'Masquer les archivés',
  'Show archived': 'Afficher les archivés',
  'No engagement on file': 'Aucun mandat enregistré',
  'Signet keeps one register per engagement, and every gate, proposal and SOW hangs off one.': 'Signet tient un registre par mandat, et chaque gate, chaque proposition et chaque SOW s’y rattache.',
  'The first move is already stated at the top of this page, with its route; it is not repeated here.': 'Le premier coup est déjà indiqué en haut de cette page, avec sa route ; il n’est pas répété ici.',
  'There is no client on file either, and the engagement form needs one — so the first move is a client, not an engagement.': 'Aucun client n’est non plus enregistré, et le formulaire de mandat en requiert un — le premier coup est donc un client, pas un mandat.',
  // engagement row
  'Fixed price': 'Forfait',
  'Time & materials': 'En régie',
  'Capped T&M': 'Régie plafonnée',
  'Retainer': 'Retainer',
  'last movement': 'dernier mouvement il y a',
  'd ago': 'jours',
  'More for {code}': 'Plus sur {code}',
  'Open the lifecycle': 'Ouvrir le cycle de vie',
  'Preview as client': 'Aperçu en tant que client',
  'Delete {code}…': 'Supprimer {code}…',
  'Qualify': 'Qualification',
  'Discovery': 'Discovery',
  'Design': 'Conception',
  'Mobilise': 'Mobilisation',
  'Implement': 'Réalisation',
  'Handover': 'Transfert',
  'Close (phase)': 'Clôture',
  'phase': 'phase',
  'of': 'sur',
  'automatic': 'automatique',
  'manual': 'manuel',
  'gate': 'gate',
  'the gate engine did not answer': 'le moteur de gate n’a pas répondu',
  'tally unknown': 'bilan inconnu',
  'documents': 'documents',
  'register': 'registre',
  'agent': 'agent',
  'proposals': 'propositions',
  'contracting': 'contrat',
  'acceptance': 'acceptation',
  // delete modal
  'Delete': 'Supprimer',
  'cannot be deleted': 'ne peut pas être supprimé',
  "for {client} goes, and so does everything recorded inside it. There is no undo and no archive to fall back on afterwards. Documents are client-owned — only this engagement's": 'pour {client} disparaît, et avec lui tout ce qui y est enregistré. Il n’y a pas d’annulation possible, ni d’archive de repli après coup. Les documents appartiennent au client — seuls les',
  'links': 'liens',
  'are removed; the files stay in the client library.': 'de ce mandat sont retirés ; les fichiers restent dans la bibliothèque client.',
  'Nothing has been recorded against it yet.': 'Rien n’a encore été enregistré à son sujet.',
  'The agent workspace under': 'L’espace de travail de l’agent sous',
  'is removed too.': 'est également supprimé.',
  'An extraction run is using it right now, so it will be left in place and has to be cleared by hand.': 'Une exécution d’extraction l’utilise actuellement ; il reste donc en place et doit être vidé à la main.',
  'Type {token} to confirm': 'Saisissez {token} pour confirmer',
  'Cancel': 'Annuler',
  'Deleting…': 'Suppression…',
  'Delete {code} permanently': 'Supprimer {code} définitivement',
  'Already archived': 'Déjà archivé',
  'Archive instead': 'Archiver à la place',
}, 'DashboardPage');
